(function () {
  function escapeSelectorValue(value) {
    if (window.CSS && typeof window.CSS.escape === "function") {
      return window.CSS.escape(value)
    }
    return String(value).replace(/["\\]/g, "\\$&")
  }

  function toPath(url) {
    return "".concat(url.pathname).concat(url.search).concat(url.hash)
  }

  function getProductData(formEl) {
    var productScript = formEl.querySelector('script[data-product-json]')
    if (!productScript) return null
    try {
      return JSON.parse(productScript.textContent)
    } catch (e) {
      return null
    }
  }

  function getVariantById(product, variantId) {
    return product.variants.find(function (variant) {
      return String(variant.id) === String(variantId)
    })
  }

  function getVariantFromSelections(product, selectedValues) {
    return product.variants.find(function (variant) {
      return selectedValues.every(function (value, index) {
        return variant["option".concat(index + 1)] === value
      })
    })
  }

  function initDawnPdpWrapper(wrapper) {
    if (!wrapper || wrapper.dataset.dawnPdpInitialized === "true") return
    wrapper.dataset.dawnPdpInitialized = "true"

    var formEl = wrapper.closest("form.product-main-form")
    if (!formEl) return

    var product = getProductData(formEl)
    if (!product || !product.variants || !product.variants.length) return

    var optionGroups = Array.from(wrapper.querySelectorAll("[data-option-position]"))
    var submitButton = wrapper.querySelector("[data-dawn-atc]")
    var submitText = wrapper.querySelector("[data-dawn-atc-text]")
    var loadingSpinner = submitButton ? submitButton.querySelector(".loading__spinner") : null
    var errorTarget = wrapper.querySelector("[data-dawn-form-error]")
    var quantitySelect = wrapper.querySelector('select[name="quantity"]')
    var hiddenIdInputs = Array.from(formEl.querySelectorAll('input[name="id"]'))

    var addToCartText = wrapper.dataset.addToCartText || "Add to cart"
    var soldOutText = wrapper.dataset.soldOutText || "Sold out"
    var unavailableText = wrapper.dataset.unavailableText || "Unavailable"
    var selectOptionsText = wrapper.dataset.selectOptionsText || "Select size"

    var currentVariant = null

    function getSelectedOptionValues() {
      return optionGroups.map(function (groupEl) {
        var checkedInput = groupEl.querySelector('input[type="radio"]:checked')
        return checkedInput ? checkedInput.value : null
      })
    }

    function setHiddenVariantId(variantId) {
      hiddenIdInputs.forEach(function (input) {
        input.value = variantId ? String(variantId) : ""
      })
    }

    function syncVariantUrl(variantId) {
      if (!variantId) return
      var url = new URL(window.location.href)
      url.searchParams.set("variant", String(variantId))
      var nextPath = toPath(url)
      window.history.replaceState({ path: nextPath }, "", nextPath)
    }

    function setButtonState(variant, allSelected) {
      if (!submitButton || !submitText) return
      if (!allSelected) {
        submitButton.disabled = true
        submitText.textContent = selectOptionsText
        return
      }
      if (!variant) {
        submitButton.disabled = true
        submitText.textContent = unavailableText
        return
      }
      submitButton.disabled = !variant.available
      submitText.textContent = variant.available ? addToCartText : soldOutText
    }

    function selectOptionsFromVariant(variant) {
      if (!variant) return
      optionGroups.forEach(function (groupEl, index) {
        var value = variant["option".concat(index + 1)]
        if (!value) return
        var selector = 'input[type="radio"][value="'.concat(escapeSelectorValue(value), '"]')
        var input = groupEl.querySelector(selector)
        if (input) input.checked = true
      })
    }

    function updateLegendValues() {
      optionGroups.forEach(function (groupEl) {
        const checkedInput = groupEl.querySelector('input[type="radio"]:checked')
        const legendValue = groupEl.querySelector(".pdp-main-form-dawn__legend-value")
        if (!legendValue) return
        if (!checkedInput) {
          legendValue.textContent = ""
          return
        }
        if (groupEl.hasAttribute("data-variety-legend"))
          legendValue.textContent = " " + checkedInput.value
        else
          legendValue.textContent = ": " + checkedInput.value
      })
    }

    function resolveCurrentVariant() {
      var selectedValues = getSelectedOptionValues()
      var allSelected = selectedValues.every(function (value) {
        return Boolean(value)
      })

      currentVariant = allSelected ? getVariantFromSelections(product, selectedValues) : null
      setHiddenVariantId(currentVariant && currentVariant.id)
      setButtonState(currentVariant, allSelected)
      updateLegendValues()
      if (currentVariant) {
        syncVariantUrl(currentVariant.id)
      }
    }

    function showError(message) {
      if (!errorTarget) return
      errorTarget.textContent = message || "Unable to add to cart."
    }

    function clearError() {
      if (!errorTarget) return
      errorTarget.textContent = ""
    }

    var urlVariantId = new URL(window.location.href).searchParams.get("variant")
    if (urlVariantId) {
      var urlVariant = getVariantById(product, urlVariantId)
      if (urlVariant) {
        selectOptionsFromVariant(urlVariant)
      }
    }

    resolveCurrentVariant()

    wrapper.addEventListener("change", function (event) {
      if (event.target && event.target.matches('input[type="radio"][name^="options["]')) {
        resolveCurrentVariant()
      }
    })

    function collectProperties() {
      const properties = {}
      Array.from(formEl.querySelectorAll('[name^="properties["]')).forEach(function (field) {
        if (field.disabled) return
        if (field.type === "checkbox" && !field.checked) return
        const match = field.name.match(/^properties\[(.+)\]$/)
        if (!match || field.value === "") return
        properties[match[1]] = field.value
      })
      return Object.keys(properties).length > 0 ? properties : undefined
    }

    formEl.addEventListener(
      "submit",
      async function (event) {
        var submitter = event.submitter || document.activeElement
        if (submitter && !wrapper.contains(submitter)) return
        event.preventDefault()
        event.stopImmediatePropagation()
        clearError()

        if (!currentVariant || !currentVariant.available) return

        var quantity = parseInt((quantitySelect && quantitySelect.value) || "1", 10)
        if (!Number.isFinite(quantity) || quantity < 1) quantity = 1

        submitButton.setAttribute("aria-disabled", "true")
        submitButton.disabled = true
        submitButton.classList.add("loading")
        if (loadingSpinner) loadingSpinner.classList.remove("hidden")

        const cartBody = { id: currentVariant.id, quantity: quantity, sections: "mini-cart" }
        const properties = collectProperties()
        if (properties) cartBody.properties = properties

        // Open the drawer now on a skeleton instead of after the response
        const cartDrawer = document.querySelector("cart-drawer")
        const isOpeningCartEarly = typeof (cartDrawer && cartDrawer.openWithSkeleton) === "function"
        if (isOpeningCartEarly) cartDrawer.openWithSkeleton()

        try {
          const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(cartBody),
          })
          var data = await response.json()

          if (!response.ok || data.status) {
            if (isOpeningCartEarly) cartDrawer.hideLineItemSkeleton()
            showError(data.description || data.message)
            return
          }

          document.dispatchEvent(
            new CustomEvent("cartaddsuccess", {
              detail: {
                variantId: currentVariant.id,
                sectionContent: data && data.sections ? data.sections["mini-cart"] : null,
              },
            }),
          )
        } catch (error) {
          if (isOpeningCartEarly) cartDrawer.hideLineItemSkeleton()
          showError(error && error.message)
        } finally {
          submitButton.classList.remove("loading")
          submitButton.removeAttribute("aria-disabled")
          if (loadingSpinner) loadingSpinner.classList.add("hidden")
          setButtonState(currentVariant, true)
        }
      },
      true,
    )
  }

  function initAllDawnPdpMainForms() {
    document.querySelectorAll("[data-dawn-pdp-main-form]").forEach(initDawnPdpWrapper)
  }

  window.initDawnPdpMainForm = initAllDawnPdpMainForms

  document.addEventListener("DOMContentLoaded", function () {
    initAllDawnPdpMainForms()
  })
})()
